import { render } from "./ShippingSetupComponent.vue?vue&type=template&id=68a995df"
import script from "./ShippingSetupComponent.vue?vue&type=script&lang=js"
export * from "./ShippingSetupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ShippingSetup/ShippingSetupComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68a995df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68a995df', __exports__)) {
    api.reload('68a995df', __exports__)
  }
  
  module.hot.accept("./ShippingSetupComponent.vue?vue&type=template&id=68a995df", () => {
    api.rerender('68a995df', render)
  })

}


export default __exports__